import { STATUS_CATEGORIES as CATEGORIES } from "@taskflow/client-core/boards";

import type { PickerOption } from "@/shared/ui";

/** Категории статуса для отчётности (§17.4) — общие с приложением. */
export const STATUS_CATEGORIES: PickerOption[] = [...CATEGORIES];
